import moment from 'moment'
import cn from 'classnames'

import styles from './selector-group-date-view.module.scss'

type Props = {
  className?: string
  weekdayIndex: number
  currentHours: number | null
  currentMinutes: number | null
  showWeeks?: boolean
}

export const SelectorGroupDateView = ({
  className,
  weekdayIndex,
  currentHours,
  currentMinutes,
  showWeeks,
}: Props) => {
  const weekday = showWeeks ? moment.weekdays(true, weekdayIndex) || '----' : ''
  const hours = currentHours === null ? '--' : String(currentHours)
  const minuted = currentMinutes === null ? '--' : String(currentMinutes).padStart(2, '0')
  return <div className={cn(styles.root, className)}>{`${weekday} ${hours}:${minuted}`}</div>
}
